import { __rest } from "tslib";
import * as React from 'react';
import BellIcon from '@patternfly/react-icons/dist/js/icons/bell-icon';
import CheckCircleIcon from '@patternfly/react-icons/dist/js/icons/check-circle-icon';
import ExclamationCircleIcon from '@patternfly/react-icons/dist/js/icons/exclamation-circle-icon';
import ExclamationTriangleIcon from '@patternfly/react-icons/dist/js/icons/exclamation-triangle-icon';
import InfoCircleIcon from '@patternfly/react-icons/dist/js/icons/info-circle-icon';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer';
import a11yStyles from '@patternfly/react-styles/css/utilities/Accessibility/accessibility';
export var variantIcons = {
  success: CheckCircleIcon,
  danger: ExclamationCircleIcon,
  warning: ExclamationTriangleIcon,
  info: InfoCircleIcon,
  default: BellIcon
};
export var NotificationDrawerListItemHeader = function NotificationDrawerListItemHeader(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$icon = _a.icon,
      icon = _a$icon === void 0 ? null : _a$icon,
      srTitle = _a.srTitle,
      title = _a.title,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'default' : _a$variant,
      props = __rest(_a, ["children", "className", "icon", "srTitle", "title", "variant"]);

  var Icon = variantIcons[variant];
  return React.createElement(React.Fragment, null, React.createElement("div", Object.assign({}, props, {
    className: css(styles.notificationDrawerListItemHeader, className)
  }), React.createElement("span", {
    className: css(styles.notificationDrawerListItemHeaderIcon)
  }, icon ? icon : React.createElement(Icon, null)), React.createElement("h2", {
    className: css(styles.notificationDrawerListItemHeaderTitle)
  }, srTitle && React.createElement("span", {
    className: css(a11yStyles.screenReader)
  }, srTitle), title)), children && React.createElement("div", {
    className: css(styles.notificationDrawerListItemAction)
  }, children));
};